import { Auth, RecaptchaVerifier } from "firebase/auth";
import { useState } from "react";

import { useSyncEffect } from "hooks/effects";

export function useRecaptcha(auth: Auth, componentId: string) {
  const [recaptcha, setRecaptcha] = useState<RecaptchaVerifier>();

  useSyncEffect(() => {
    const recaptchaVerifier = new RecaptchaVerifier(auth, componentId, {
      size: "invisible",
    });

    setRecaptcha(recaptchaVerifier);

    return () => {
      recaptchaVerifier.clear();
    };
  }, [auth, componentId]);

  const refreshRecaptcha = () => {
    const recaptchaVerifier = new RecaptchaVerifier(auth, componentId, {
      size: "invisible",
    });

    setRecaptcha(recaptchaVerifier);
    return recaptchaVerifier;
  };

  return { recaptcha, refreshRecaptcha };
}
